import React from 'react';
import PropTypes from 'prop-types';
import ManagedInput from 'components/form/managed_input';

import classNames from 'classnames';

export default function ToggleOverrideSection({ checked, className, name, subtitle, title, onOverride, onRemove }) {
  return (
    <div className={classNames('mt-1 mb-4', { 'border-bottom pb-3': !checked }, className)}>
      <ManagedInput
        name={name}
        type="checkbox"
        value={checked}
        onValueChange={checked ? onOverride : onRemove}
      >
        <strong className="fw-semibold my-2">{title}</strong>
      </ManagedInput>
      <div className="text-muted ms-4">
        { subtitle }
      </div>
    </div>
  );
}

ToggleOverrideSection.propTypes = {
  checked: PropTypes.bool.isRequired,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  onOverride: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
};
